export default __webpack_public_path__ + "static/media/judgement.1b89d0f0.png";